import { createContext, useContext, useEffect, useState } from "react";
import socket from "./socket";
import api from "../hooks/apiClient"; // your axios instance

const SocketContext = createContext(null);

export const SocketProvider = ({ storeId, children }) => {
  const [isConnected, setIsConnected] = useState(false);

  const refreshToken = async () => {
    const res = await api.post("/auths/refresh");
    localStorage.setItem("token", res.data.accessToken);
    return res.data.accessToken;
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || !storeId) return;

    socket.auth = { token };
    socket.connect();

    socket.on("connect", () => {
      setIsConnected(true);
      socket.emit("join-store", storeId);
    });

    socket.on("disconnect", () => {
      setIsConnected(false);
    });

    let isRefreshing = false;
    socket.on("connect_error", async (err) => {
      if (err.message === "jwt expired" && !isRefreshing) {
        isRefreshing = true;
        try {
          const newToken = await refreshToken();
          socket.auth.token = newToken;
          socket.connect();
        } finally {
          isRefreshing = false;
        }
      }
    });

    return () => {
      socket.emit("leave-store", storeId);
      socket.off(); // cleanup listeners
      socket.disconnect();
    };
  }, [storeId]);

  return (
    <SocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);

// import { createContext, useContext, useEffect, useState } from "react";
// import socket from "./socket";

// const SocketContext = createContext(null);

// export const SocketProvider = ({ storeId, children }) => {
//   const [isConnected, setIsConnected] = useState(false);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (!token || !storeId) return;

//     socket.auth = { token };
//     socket.connect();

//     socket.on("connect", () => {
//       setIsConnected(true);
//       socket.emit("join-store", storeId);
//     });

//     socket.on("disconnect", () => {
//       setIsConnected(false);
//     });

//     socket.on("connect_error", (err) => {
//       console.error("WebSocket error:", err.message);
//     });

//     return () => {
//       socket.emit("leave-store", storeId);
//       socket.disconnect();
//       socket.off();
//     };
//   }, [storeId]);

//   return (
//     <SocketContext.Provider value={{ socket, isConnected }}>
//       {children}
//     </SocketContext.Provider>
//   );
// };

// export const useSocket = () => useContext(SocketContext);

// import { useEffect, useRef, useCallback, useState } from "react";
// import { io } from "socket.io-client";

// const useSocket = (storeId) => {
//   const socketRef = useRef(null);
//   const [isConnected, setIsConnected] = useState(false);

//   const getSocketUrl = () =>
//     process.env.REACT_APP_WS_URL ||
//     (window.location.hostname === "velvour.vnoirs.com"
//       ? "wss://multi.vnoirs.com"
//       : "ws://localhost:5500");

//   const connect = useCallback(() => {
//     if (!storeId) return;

//     const token = localStorage.getItem("token"); // Read fresh token
//     if (!token) {
//       console.warn("No JWT token found in localStorage");
//       return;
//     }

//     const socketUrl = getSocketUrl();
//     console.log("Connecting to WebSocket at:", socketUrl);

//     const socket = io(socketUrl, {
//       transports: ["websocket", "polling"],
//       auth: { token }, // pass JWT
//       withCredentials: true,
//     });

//     socketRef.current = socket;

//     socket.on("connect", () => {
//       console.log("WebSocket connected:", socket.id);
//       setIsConnected(true);
//       socket.emit("join-store", storeId);
//     });

//     socket.on("disconnect", () => {
//       console.log("WebSocket disconnected");
//       setIsConnected(false);
//     });

//     socket.on("connect_error", (err) => {
//       console.error("WebSocket connection error:", err.message);
//     });

//     return socket;
//   }, [storeId]);

//   const disconnect = useCallback(() => {
//     if (socketRef.current) {
//       socketRef.current.emit("leave-store", storeId);
//       socketRef.current.disconnect();
//       socketRef.current = null;
//       setIsConnected(false);
//     }
//   }, [storeId]);

//   useEffect(() => {
//     disconnect(); // ensure cleanup
//     if (storeId) {
//       connect();
//     }
//     return disconnect;
//   }, [storeId, connect, disconnect]);

//   return {
//     socket: socketRef.current,
//     isConnected,
//     emit: (event, data) => socketRef.current?.emit(event, data),
//     on: (event, callback) => socketRef.current?.on(event, callback),
//     off: (event, callback) => socketRef.current?.off(event, callback),
//   };
// };

// export default useSocket;
